var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewButton({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    fill: "#F3F6F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M22.475 14.007C20.858 11.4641 18.492 10 16 10C14.754 10 13.543 10.3643 12.437 11.0438C11.331 11.7303 10.337 12.732 9.525 14.007C8.825 15.1068 8.825 16.8932 9.525 17.993C11.142 20.5429 13.508 22 16 22C17.246 22 18.457 21.6357 19.563 20.9562C20.669 20.2697 21.663 19.268 22.475 17.993C23.175 16.9002 23.175 15.1068 22.475 14.007ZM16 18.8336C14.432 18.8336 13.172 17.5657 13.172 16.0035C13.172 14.4413 14.432 13.1734 16 13.1734C17.568 13.1734 18.828 14.4413 18.828 16.0035C18.828 17.5657 17.568 18.8336 16 18.8336Z",
    fill: "#26875C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9965 14C14.8967 14 14 14.8967 14 16.0035C14 17.1033 14.8967 18 15.9965 18C17.0963 18 18 17.1033 18 16.0035C18 14.9037 17.0963 14 15.9965 14Z",
    fill: "#26875C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewButton);
export default __webpack_public_path__ + "static/media/ViewButton.c21927349bf2d6970dcd90e09fde8d1f.svg";
export { ForwardRef as ReactComponent };